'use client'

import Modal from '@/components/Modal/Modal'
import { X } from 'lucide-react'

interface EdgeInfoModalProps {
  isOpen: boolean
  onClose: () => void
  edgeData?: {
    tag: string
    description?: string
    condition?: string
  }
}

export function EdgeInfoModal({ isOpen, onClose, edgeData }: EdgeInfoModalProps) {
  if (!edgeData) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="max-w-lg rounded-lg bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">Edge Condition Details</h3>
          <button
            onClick={onClose}
            className="rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Edge Tag</label>
            <div className="mt-1 rounded-md bg-gray-50 px-3 py-2 text-sm text-gray-900">
              {edgeData.tag}
            </div>
          </div>

          {edgeData.description && (
            <div>
              <label className="block text-sm font-medium text-gray-700">Description</label>
              <div className="mt-1 rounded-md bg-gray-50 px-3 py-2 text-sm text-gray-900">
                {edgeData.description}
              </div>
            </div>
          )}

          {edgeData.condition && (
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Condition Expression
              </label>
              <div className="mt-1 rounded-md bg-gray-50 px-3 py-2 font-mono text-sm text-gray-900">
                {edgeData.condition}
              </div>
              <p className="mt-1 text-xs text-gray-500">
                This edge will only be followed when the condition evaluates to true
              </p>
            </div>
          )}

          {!edgeData.condition && (
            <div className="rounded-md bg-blue-50 p-3">
              <p className="text-sm text-blue-800">
                This edge has no conditions and will always be available for selection.
              </p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}
